module.exports = __webpack_public_path__ + "static/media/game_big.cdabc8b1.png";